import { isRecord } from "../../utils/index.js";
const ObjectFlattener = (keyMapper) => {
    const flatten = (object, parent = "") => {
        if (Array.isArray(object)) {
            return object.flatMap((value, i) => flatten(value, parent == "" ? i.toString() : keyMapper.onArray(parent, i)));
        }
        if (isRecord(object)) {
            return Object.entries(object).flatMap(([key, value]) => flatten(value, parent === "" ? key : keyMapper.onObject(parent, key)));
        }
        return [[parent, object]];
    };
    return flatten;
};
export const flattenForFormData = (object) => {
    const flatten = ObjectFlattener({
        onArray: (parent, index) => `${parent}[${index}]`,
        onObject: (parent, key) => `${parent}[${key}]`,
    });
    return Object.fromEntries(flatten(object));
};
export const flattenForRailsQueryString = (object) => {
    const flatten = ObjectFlattener({
        onArray: (parent) => `${parent}[]`,
        onObject: (parent, key) => `${parent}[${key}]`,
    });
    return flatten(object)
        .filter(([, v]) => v != undefined)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");
};
